import { object, string } from "yup";

export const BillComValidation = () =>
  object({
    syncToken: string().required("Sync Token is required"),
    tokenPassword: string().required("Token Password is required"),
    organizationId: string().required("Organization ID is required"),
    developerKey: string().required("Developer Key is required"),
  });
